import { tracking } from '@iwoca/frontend-tracking-library';

export const initialise = () => {
    tracking.initialise({
        environment: getEnvironment()
        // disabled: process.env.NODE_ENV === 'test'
    });
};

export const identify = (data: {
    stateKey: string;
    country: 'UK' | 'DE';
    isImpersonating: boolean;
}) => {
    tracking.identifyCustomer(data);
};

const getEnvironment = () =>
    ['www.iwoca.co.uk', 'www.iwoca.de'].includes(window.location.host)
        ? 'production'
        : 'development';
